/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2016, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../DynamicFileLoader'
], function(Class, DynamicFileLoader) {
	'use strict';

	var Action = Class.extend({
		/**
		 * if necessary set visibility on condition,
		 * extra options parameter can be passed in
		 */
		isItemVisible: function() {
			return true;
		},

		/**
		 * Callback when select a context menu item
		 *
		 * @param context {object}
		 * */
		onSelectItem: function(context) {
			var oTarget = context.target;
			let result;
			switch (oTarget.itemId) {
				case 'com.ibm.bi.dashboard.dataSources.relinkDataSource': {
					const oActiveObject = oTarget.activeObject;
					if (oActiveObject) {
						result = DynamicFileLoader.load([oActiveObject.dialogModule])
							.then((modules) => {
								const dashboardApi = context.glassContext.appController.getCurrentContentView().getDashboardApi();
								const dialogOptions = {
									dashboardApi,
									'dataSource': oActiveObject.dataSource,
									'dataSourceName': oActiveObject.dataSourceName
								};
								const requiredCapability = this._getRequiredCapabilityToRelink(dashboardApi);
								if (requiredCapability) {
									dialogOptions.capabilitiesRequired = [ requiredCapability ];
								}
								var openDialog = new modules[0](dialogOptions);
								openDialog.open();
								return openDialog;
							});
					}
					break;
				}
				default:
					//Default behavior
			}
			return result;
		},

		_getRequiredCapabilityToRelink(dashboard) {
			const capabilitiesFeature = dashboard.getFeature('Capabilities');
			return capabilitiesFeature && capabilitiesFeature.getCurrentAuthoringCapability();
		}
	});

	return Action;
});
